(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oo-waitlist-dialog"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-oo-waitlist]');
    if (!dialog) return;
    var tagsInput = dialog.querySelector('[data-oo-waitlist-tags]');
    var forLine = dialog.querySelector('[data-oo-waitlist-for]');

    function slug(text) {
      return String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    // Work out which product (and which piece) the opening button belongs to.
    function productFor(opener) {
      var info = {
        handle: opener.getAttribute('data-oo-waitlist-product') || '',
        title: opener.getAttribute('data-oo-waitlist-title') || '',
        piece: ''
      };
      if (!info.handle) {
        var holder = opener.closest('[data-product-url]');
        var link = holder ? holder.getAttribute('data-product-url') : '';
        if (!link) {
          var card = opener.closest('product-card');
          var a = card && card.querySelector('a[href*="/products/"]');
          link = a ? a.getAttribute('href') : '';
        }
        var match = link.match(/\/products\/([^/?#]+)/);
        if (match) info.handle = match[1];
      }
      // On a product page, use its title and the ticked options (e.g. Select 16 / Size One)
      var details = opener.closest('.product-information');
      if (details) {
        if (!info.title) {
          var titleEl = details.querySelector('.product-details [class*="product_title"]');
          if (titleEl) info.title = titleEl.textContent.trim();
        }
        var ticked = Array.prototype.map.call(
          details.querySelectorAll('variant-picker fieldset input:checked'),
          function (input) { return input.value; }
        );
        info.piece = ticked.join(' / ');
      }
      if (!info.title && info.handle) info.title = info.handle.replace(/-/g, ' ');
      return info;
    }

    function prepare(opener) {
      var tags = ['newsletter', 'waitlist'];
      var info = productFor(opener);
      if (info.handle) {
        tags.push('waitlist-' + info.handle);
        if (info.piece) tags.push('waitlist-' + info.handle + '-' + slug(info.piece));
      }
      if (tagsInput) tagsInput.value = tags.join(',');
      if (forLine) {
        var label = [info.title, info.piece].filter(Boolean).join(' · ');
        forLine.textContent = label ? 'For: ' + label : '';
        forLine.hidden = !label;
      }
    }

    // Fresh form each time the pop-up is opened by a button: hide any old
    // thank-you / error message and empty the email box.
    function resetForm() {
      var success = dialog.querySelector('[data-oo-waitlist-success]');
      if (success) success.hidden = true;
      dialog.querySelectorAll('.errors').forEach(function (el) { el.hidden = true; });
      var row = dialog.querySelector('[data-oo-waitlist-row]');
      if (row) row.hidden = false;
      var email = dialog.querySelector('#oo-waitlist-email');
      if (email) email.value = '';
    }

    // Capture phase, so this runs before the theme's add-to-cart handler
    // (which would otherwise flash "Added" on the waitlist button).
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-oo-waitlist-open]');
      if (!opener) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      resetForm();
      prepare(opener);
      dialog.showModal();
    }, true);

    // After showing a result, tidy the address so a refresh doesn't reopen it
    dialog.addEventListener('close', function () {
      if (window.location.hash === '#oo-waitlist-form' || /customer_posted=true/.test(window.location.search)) {
        var url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('customer_posted');
        history.replaceState({}, '', url.toString());
      }
    });
    dialog.querySelectorAll('[data-oo-waitlist-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dialog.close();
      });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    // Reopen after a sign-up only to show the thank-you or an error message.
    // Never on Shopify's "I am human" check page (/challenge), which keeps the #oo-waitlist-form tag.
    var onChallengePage = window.location.pathname.indexOf('/challenge') === 0;
    var hasResult = dialog.querySelector('.oo-waitlist__success, .errors');
    if (window.location.hash === '#oo-waitlist-form' && !onChallengePage && hasResult) {
      dialog.showModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
